<h1 class="modal-title has-status is-error" id="message-title">
  <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
    <use href="#icon-error"></use>
  </svg>{{'Error' | translate}}

</h1>
<div class="message" id="message-text">{{error.message}}</div>

<div style="display: flex; padding-top: 5px;">
  <section class="scrollable-flex-header expandable-area customInlineExpand" [class.is-expanded]="false">
    <div class="expandable-pane">
      <pre class="details">{{error.details}}></pre>
    </div>
    <div class="expandable-footer">
      <a href="#" class="expandable-expander hyperlink hide-focus">
        <span>{{showDetailsMsg}}</span>
      </a>
    </div>
  </section>
</div>
